import Loadable from "@loadable/component";

const SignUp = Loadable(
  () => import(/* webpackChunkName: "signup_page" */ "./signUp")
);

export default SignUp;
